<div>
  <span class="text">{{ message }}</span>
</div>
